module.exports = {
      id: "plus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#plus",
      toString: function () {
        return this.url;
      }
    }